export class SkuPercentageDto{

    finalPercentage:number;
    
    constructor(finalPercentage:number)
    {
       this.finalPercentage = finalPercentage;
    }
}